export default function makeFormData(formValues) {
    const formData = new FormData();
    for (let [key, value] of Object.entries(formValues)) {
        formData.append(key, value);
    }
    return formData;
}